/* Dastoor theme, lightweight interactions */
(function () {
  'use strict';

  // Mobile menu toggle
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');

    if (toggle) {
      var nav = document.querySelector('[data-menu]');
      if (nav) nav.classList.toggle('is-open');
    }
  });

  // Product page, thumbnail to main image swap
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');

    if (thumb) {
      var main = document.getElementById('ProductMainImage');
      if (main) main.src = thumb.getAttribute('data-thumb');
    }
  });

  // Product page, sync size selection to Shopify variant and visible price
  var form = document.getElementById('ProductForm');

  if (form) {
    var select = document.getElementById('ProductVariantSelect');
    var priceContainer = document.getElementById('ProductPrice');

    function currentOptions() {
      return Array.prototype.map.call(
        form.querySelectorAll('input[type=radio]:checked'),
        function (input) {
          return input.value;
        }
      ).join(' / ');
    }

    function updatePrice(variantOption) {
      if (!variantOption || !priceContainer) return;

      var price = variantOption.getAttribute('data-price');
      var comparePrice = variantOption.getAttribute('data-compare-price');
      var onSale = variantOption.getAttribute('data-on-sale') === 'true';

      if (onSale) {
        priceContainer.innerHTML =
          '<span class="price price--sale">' + price + '</span>' +
          '<s class="price price--compare">' + comparePrice + '</s>';
      } else {
        priceContainer.innerHTML =
          '<span class="price">' + price + '</span>';
      }
    }

    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[type=radio]') || !select) return;

      var chosen = currentOptions();
      var matchedVariant = null;

      Array.prototype.forEach.call(select.options, function (option) {
        if (option.getAttribute('data-title') === chosen) {
          matchedVariant = option;
        }
      });

      if (!matchedVariant) return;

      select.value = matchedVariant.value;
      updatePrice(matchedVariant);

      // Lets any other Shopify/theme listeners know the selected variant changed.
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
})();